import React, {useState,   useEffect} from 'react';

import BreadCrumbs from "../../../layouts/breadcrumbs/BreadCrumbs"
import ContentWrapper from  '../../../components/Layout/ContentWrapper'
import Progress from './Progress'

import Price from './Price'
import Personal from './Personal'
import EmailAddress from './EmailAddress'
import EmailVerification from './EmailVerification'
import Confirmation from './Confirmation'
import Domain from './Domain'

const Register = () => {

  const [cid, setCid] = useState(1)
  const [step_index, set_step_index] = useState(0)


  const [registration, set_registration] = useState({
    "price_id": 2,
    "first_name" : '',
    "last_name" :  '',
    'company_name' : '',
    "email":  '',
    "domain" : '',
    'verification_code': '',
    'sent_verification_code': false,
     'verified_code': false
  });


  const STEP_1_CHOOSE_PRICE = 0
  const STEP_2_PERSONNEL = 1
  const STEP_3_EMAIL_ADDRESS = 2
  const STEP_4_EMAIL_VERIFICATION = 3
  const STEP_5_CHOOSE_DOMAIN = 4
  const STEP_6_CONFIRMATION = 5

  const submit_registration = (domain) => {
      console.log('submit_registration')
      console.log(registration)
      set_domain(domain)
  }

  const set_price_id = (price_id) => {
      set_registration((old) =>  ({...old, price_id : price_id }))
  }


  const set_first_name = (first_name) => {
      set_registration((old) =>  ({...old, first_name : first_name }))
  }

  const set_last_name = (last_name) => {
      set_registration((old) =>  ({...old, last_name : last_name }))
  }

 const set_email = (email) => {
      set_registration((old) =>  ({...old, email : email }))
  }


  const set_verification_code = (verification_code) => {
      set_registration((old) =>  ({...old, verification_code : verification_code }))
  }


  const set_company_name = (company_name) => {
      set_registration((old) =>  ({...old, company_name : company_name }))
  }


  const set_sent_verification_code = (sent_verification_code) => {
     set_registration((old) =>  ({...old, sent_verification_code : sent_verification_code }))
  }

  const set_verified_code = (verified_code) => {
     set_registration((old) =>  ({...old, verified_code : verified_code }))
  }


  const set_domain = (domain) => {
      const data = { ...registration , domain : domain }
  }


const next_step = () => {
    console.log('show next has been clicked!')
    set_step_index(step_index == 6 ? step_index : step_index + 1 )
  }

  const prev_step = () => {
    console.log('show prev has been clicked!')
    set_step_index(step_index == 0 ? step_index : step_index - 1 )
  }


  const setPlanId = (planid) => {
       console.log('set plan id has been called')
       setData((old)=> {
         const updated = {
          ...old, 
          'plan_id': planid 
         }
         console.log(updated)
         return updated
       })
    }

  
  return (
   <ContentWrapper colspan={'10'}>
  <BreadCrumbs />

  <Progress active_step={step_index}/>


   {step_index === STEP_1_CHOOSE_PRICE && (
     <Price
        next_step = {next_step}
        prev_step = {prev_step}
        price_id = {registration.price_id}
        set_price_id = {set_price_id}
    />)
  }


  {step_index ===  STEP_2_PERSONNEL && (
     <Personal

        next_step = {next_step}
        prev_step = {prev_step}

        first_name = {registration.first_name}
        last_name = {registration.last_name}
        company_name = {registration.company_name}

        set_first_name = {set_first_name}
        set_last_name = {set_last_name}
        set_company_name = {set_company_name}

    />)
}


  {

  step_index === STEP_3_EMAIL_ADDRESS && (

     <EmailAddress
        next_step = {next_step}
        prev_step = {prev_step}

        email = {registration.email}
        set_email = {set_email}


        sent_verification_code = {registration.sent_verification_code}
        set_sent_verification_code={set_sent_verification_code}
        
    />)

  }


  {step_index === STEP_4_EMAIL_VERIFICATION && (
     <EmailVerification
        next_step = {next_step}
        prev_step = {prev_step}

        email={registration.email}

        verification_code = {registration.verification_code}
        set_verification_code = {set_verification_code}

        verified_code = {registration.verified_code}
        set_verified_code = {set_verified_code}

    />)
  }


  {step_index === STEP_5_CHOOSE_DOMAIN && (
     <Domain
        next_step = {next_step}
        prev_step = {prev_step}

        price_id =  {registration.price_id}
        first_name = {registration.first_name}
        last_name = {registration.last_name}
        company_name = {registration.company_name}
        email = {registration.email}
        verification_code = {registration.verification_code}
        domain = {registration.domain}
        set_domain  = {set_domain} 
    />)
}


 { step_index === STEP_6_CONFIRMATION && (
   <Confirmation email = {registration.email} />)
 }

    </ContentWrapper>
  )
};

export default Register;
